import { create } from 'zustand';
import client from '../api/client';

const useAuthStore = create((set, get) => ({
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  token: localStorage.getItem('token') || null,
  isLoading: false,
  error: null,

  register: async (userData) => {
    set({ isLoading: true });
    try {
      const { data } = await client.post('/auth/register', userData);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      set({ user: data.user, token: data.token, error: null });
      return data;
    } catch (error) {
      set({ error: error.response?.data?.message });
      throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  login: async (email, password) => {
    set({ isLoading: true });
    try {
      const { data } = await client.post('/auth/login', { email, password });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      set({ user: data.user, token: data.token, error: null });
      return data;
    } catch (error) {
      set({ error: error.response?.data?.message });
      throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  updateProfile: async (profileData) => {
    set({ isLoading: true });
    try {
      const { data } = await client.put('/auth/profile', profileData);
      localStorage.setItem('user', JSON.stringify(data.user));
      set({ user: data.user, error: null });
      return data;
    } catch (error) {
      set({ error: error.response?.data?.message });
      throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ user: null, token: null });
  }
}));

export default useAuthStore;